'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'cannon';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e642';
var svgPathData = ['M5.1 429.5c-11.9-23.7-2.2-52.5 21.5-64.4l22.5-11.3c1 7.9 2.6 15.8 5 23.6 1.2 3.9 2.5 7.8 4.1 11.6 .8 1.9 1.6 3.8 2.4 5.8 .4 .9 .8 1.9 1.3 2.9 .4 .9 .8 1.7 1.3 2.7 7.5 15 17.3 28.2 28.8 39.3L69.5 450.9c-23.7 11.9-52.5 2.2-64.4-21.5zM288 368c0-61.9 50.1-112 112-112 41.3 0 77.4 22.3 96.8 55.6 9.7 16.6 15.2 35.8 15.2 56.4 0 61.9-50.1 112-112 112-37.4 0-70.5-18.3-90.9-46.5-13.3-18.4-21.1-41.1-21.1-65.5zm80 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z', 'M256.4 464.8c-71.1 35.6-157.6 6.7-193.2-64.4s-6.7-157.6 64.4-193.2c49.5-24 287.2-107.9 394.6-145.5 30.3-10.6 63.6 3.1 78 31.8L630.9 155c14.4 28.7 5.3 63.6-21.4 81.5-29.3 19.6-69.6 46.6-112.7 75.2-19.4-33.3-55.5-55.6-96.8-55.6-61.9 0-112 50.1-112 112 0 24.5 7.8 47.1 21.2 65.5-23.4 14.6-42 25.7-52.7 31.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCannon = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;